<div class="tw-w-[100px] tw-h-[2px] tw-rounded-[1px] tw-bg-gray-200 tw-overflow-hidden tw-mx-auto">
  <span
    class="tw-block tw-h-full tw-w-full tw-bg-teal-400 tw-origin-left tw-animate-linear_loader_fill"
    [style.animation-duration.ms]="durationMs()">
  </span>
</div>
